// extracted by mini-css-extract-plugin
export default {"fixedTopRight":"tableTop_fixedTopRight__dXCe5"};